import { render, staticRenderFns } from "./ContrastCreate.vue?vue&type=template&id=2a7bf9bc&scoped=true"
import script from "./ContrastCreate.vue?vue&type=script&lang=js"
export * from "./ContrastCreate.vue?vue&type=script&lang=js"
import style0 from "./ContrastCreate.vue?vue&type=style&index=0&id=2a7bf9bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7bf9bc",
  null
  
)

export default component.exports